export enum RECORD_STATUS {
  NEW = 'New',
  FAILED = 'Failed',
  ESCALATED = 'Escalated',
  PUBLISHED = 'Published',
  REMOVED = 'Removed',
  AUTOPUBLISHED = 'AutoPublished',
  VOID = 'Void'
}
